/**
 * Integrations has a tab per kind, `/integrations/<kind>`. A kind's catalogue (`/integrations/<kind>/add`), installs and
 * settings are sheets over its tab, and a GPS integration is a record under its tab (`/integrations/gps/:id`).
 */
export const INTEGRATIONS_PATH = '/integrations';

export const INTEGRATION_KINDS = ['sms', 'whatsapp', 'gps'] as const;
export type IntegrationKind = (typeof INTEGRATION_KINDS)[number];

export const INTEGRATION_KIND_LABELS: Record<IntegrationKind, string> = { sms: 'Text messages (SMS)', whatsapp: 'WhatsApp', gps: 'GPS tracking' };

export function integrationTabPath(kind: IntegrationKind): string {
  return `${INTEGRATIONS_PATH}/${kind}`;
}

/** The catalogue of one kind, over its tab. */
export function addIntegrationPath(kind: IntegrationKind): string {
  return `${integrationTabPath(kind)}/add`;
}
